import type { AriaAttributes } from 'react';

type TrimAriaProps<T> = {
  [P in keyof T as P extends `aria-${infer R}` ? R : never]: T[P];
};

export type AriaProps = TrimAriaProps<AriaAttributes>;

export const ariaToReactProps = (aria: AriaProps = {}): AriaAttributes =>
  Object.fromEntries(
    Object.entries(aria).map(([ariaKey, ariaValue]) => [
      `aria-${ariaKey}`,
      ariaValue,
    ]),
  );
